// extracted by mini-css-extract-plugin
export default {"container":"key_container__FU1d0","image":"key_image__yXnEj"};